$(document).ready(function() {
    // Set the current date as the placeholder for the date input
    const today = new Date().toISOString().split('T')[0];
    $('.pr_date').attr('min', today);

    function validateForm() {
        let isValid = true;
        let emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        // Clear previous error messages and classes
        $('.error-message').text('');
        $('input, textarea').removeClass('error');
        $('.error-message').removeClass('error');

        // Validate Recipient's Name
        if ($('.pr_name').val().trim() === '') {
            $('.name_error').text("Recipient's Name is required.").addClass('error');
            $('.pr_name').addClass('error');
            isValid = false;
        }

        // Validate Recipient's Email Address
        let email = $('.pr_email').val().trim();
        if (email === '') {
            $('.email_error').text("Recipient's Email Address is required.").addClass('error');
            $('.pr_email').addClass('error');
            isValid = false;
        } else if (!emailPattern.test(email)) {
            $('.email_error').text("Please enter a valid Email Address.").addClass('error');
            $('.pr_email').addClass('error');
            isValid = false;
        }

        // Validate Delivery Date
        if ($('.pr_date').val() === '') {
            $('.date_error').text("Delivery Date is required.").addClass('error');
            $('.pr_date').addClass('error');
            isValid = false;
        }

        return isValid;
    }

    function handleValidation() {
        let isValid = validateForm();
        if (isValid) {
            $('.custom_add_to_cart_properties').addClass('click_to_cart');
        } else {
            $('.custom_add_to_cart_properties').removeClass('click_to_cart');
        }
    }

    $('.custom_add_to_cart_properties').click(handleValidation);

    $('input, textarea').on('input change', function() {
        let isValid = validateForm();
        if (isValid) {
            $('.custom_add_to_cart_properties').addClass('click_to_cart');
        } else {
            $('.custom_add_to_cart_properties').removeClass('click_to_cart');
        }
    });
});

// $(document).on('click', 'body', function(){
//     $.ajax({
//         type: 'GET',
//         url: '/cart.js',
//         dataType: 'json',
//         success: function(cartdata){
//             // $('.cart-total-items .count').html(cartdata.item_count);
//             // $('.cart-total-price').html('$'+(cartdata.total_price/100).toFixed(2));
//             console.log(cartdata);
//         }
//     });
// });

$(document).on('click', '.click_to_cart', function(){
    $('.btn-container #AddToCart').trigger('click');
});

$('.fixed-product-form__atc_click_stop').off('click').on('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    if (!$('.custom_add_to_cart_properties').hasClass('click_to_cart')) {
        $('html, body').animate({
            scrollTop: $('.property_box_main').offset().top - 150
        }, 'slow');
    } else {
        $('.click_to_cart').trigger('click');
    }
});

$('.product-swatch__label').click(function(){
    let price = $(this).attr('money');
    $('.price-item').text(price);
});

let selecPrice = $('.product-swatch__group input[type=radio]:checked+label').attr('money');
$('.price-item').text(selecPrice);
